// Shared by the main REST client (axios.js) and the control-plane client
// (axiosControlPlane.js) so both authenticate and fail the same way.

export function attachBearerToken(config) {
  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  return config;
}

// Callers never see the axios error: they get this flattened object. An
// UNAUTHORIZED answer ends the session. `extraFields(data)` lets a client add
// its own diagnostics to the flattened error without forking this handler.
export const createJcnErrorRejecter = (extraFields) => (error) => {
  const data = error.response?.data;
  const jcnError = {
    message: data?.userMessage || data,
    internalCode: data?.internalCode,
    httpCode: error.response?.status,
    ...(typeof extraFields === "function" ? extraFields(data) : {}),
  };
  if (jcnError.message === "UNAUTHORIZED") {
    localStorage.clear();
    window.location.replace("/");
  }
  return Promise.reject(jcnError);
};

export const rejectAsJcnError = createJcnErrorRejecter();
